// Info: Import Local Dependancies
import { createChatBotMessage } from "./chatbot";

const config = {
    initialMessages: [createChatBotMessage(`Hello world`, {loading: false})],
  };
  
  export default config;